module.exports = __webpack_public_path__ + "submenu_award_0_active.661bebcb.png";